export default {
  //Develop
  apiUrl: 'https://fetchweapons-api.cenango.com/api/',

  //production
  // apiUrl: 'http://127.0.0.1:8082/api/',

  google: {
    analyticsKey: 'UA-xxxxxxxxx-1'
  }
};
